// Get main dom element
const recipeContainer = document.querySelector("#recipe-search-data");

// Mock implementation, real implementation will not have OR operators
const config = {
  defaultLanguage: recipeContainer?.getAttribute("data-language"),
  initialFiltersAmount: recipeContainer?.getAttribute("data-filter-count"),
  collectionSlidesPerView: recipeContainer?.getAttribute(
    "data-collection-slides-per-view"
  ),
  breadCrumbs: recipeContainer?.getAttribute("data-breadcrumbs"),
  baseUrl: recipeContainer?.getAttribute("data-baseurl"),
};

export default config;
